
import WalletCheck from "../../../assets/filled/WalletCheck.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WalletCheckIcon({ className, dataTestid = "WalletCheckIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <WalletCheck data-testid={dataTestid} className={classes} {...rest} />
  );
}
